import { PlatformPage } from './PlatformPage'
import { AuditTab } from './tabs/AuditTab'

export function AuditPage() {
  return (
    <PlatformPage
      title="Audit Log"
      description="Append-only log of every administrative action across the platform."
    >
      <AuditTab />
    </PlatformPage>
  )
}
